<div class="row my-3 mx-2 p-3">
    <div class="row">
        <div class="d-flex flex-column mb-4">
            <h1 class="sub-header-title">
                {{ this.selectedPolicy.id ? 'Edit ' : 'Assign ' }} Policy
            </h1>
        </div>
    </div>
    <div class="mt-3">
        <div class="row">
            <div class="d-flex flex-column">
                <h2 class="sub-form-header-title">
                    Insurance Policy
                </h2>
            </div>
        </div>
        <div class="row my-3 policy-form">
            <div class="col d-flex flex-column">
                <mat-form-field appearance="outline" hideRequiredMarker>
                    <mat-label>Insurance Policy<span class="red">*</span></mat-label>
                    <input type="text"
                        placeholder="Select Policy"
                        matInput
                        [formControl]="policyControl"
                        [matAutocomplete]="policyAuto">
                        <mat-error *ngIf="policyControl.errors">
                            Please select a valid Policy
                        </mat-error>
                    <mat-autocomplete autoActiveFirstOption #policyAuto="matAutocomplete" (optionSelected)="onPolicySelectionChanged($event)" [displayWith]="displayPolicyFn">
                    <mat-option *ngFor="let policy of filteredPolicies | async" [value]="policy">
                        {{ policy.name }}
                    </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </div>
        <ng-container *ngIf="!enterNewPriceRateForm">
            <div class="row mt-3 policy-form">
                <div class="d-flex flex-column">
                    <h2 class="sub-form-header-title">
                        Select Price Rate
                    </h2>
                </div>
            </div>
            <div class="row mt-3 mb-3 policy-form">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Price Rate<span class="red">*</span></mat-label>
                        <input type="text"
                            placeholder="Select Price Rate"
                            matInput
                            [formControl]="priceRateControl"
                            [matAutocomplete]="priceRateAuto">
                            <mat-error *ngIf="policyControl.errors">
                                Please select a valid Price Rate
                            </mat-error>
                        <mat-autocomplete autoActiveFirstOption #priceRateAuto="matAutocomplete" (optionSelected)="onPriceRateSelectionChanged($event)" [displayWith]="displayPriceRateFn">
                            <mat-option *ngFor="let rate of filteredPriceRates | async" [value]="rate">
                                {{ rate.name }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
            </div>
            <div class="mb-4 d-flex new-price-rate-link" (click)="onEnterNewPriceRateClick()">
                Enter New Price Rate
            </div>
        </ng-container>
        <ng-container *ngIf="enterNewPriceRateForm">
            <div class="mb-3">
                <div class="d-flex align-items-center mt-3">
                    <h2 class="sub-form-header-title">
                        Enter New Price Rate
                    </h2>
                </div>
                <div class="row mt-3 mb-4 px-2">
                    <form [formGroup]="priceRateForm">
                        <div class="row">
                            <div class="col d-flex flex-column">
                                <mat-form-field appearance="outline" hideRequiredMarker>
                                    <mat-label>Name<span class="required-input">*</span></mat-label>
                                    <input type="text" matInput placeholder="Enter Price Rate Name" formControlName="name">
                                </mat-form-field>
                            </div>
                            <div class="col d-flex flex-column">
                                <mat-form-field appearance="outline" hideRequiredMarker>
                                    <mat-label>Price For<span class="required-input">*</span></mat-label>
                                    <mat-select formControlName="type_id">
                                        <mat-option *ngFor="let priceType of priceTypesArray" [value]="priceType.id.toString()">
                                            {{ priceType.display_text }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col d-flex flex-column">
                                <mat-form-field appearance="outline" hideRequiredMarker>
                                    <mat-label>Pricing Model<span class="required-input">*</span></mat-label>
                                    <mat-select formControlName="pricing_model_id">
                                        <mat-option *ngFor="let priceModel of pricingModels" [value]="priceModel.id.toString()">
                                            {{ priceModel.display_text }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col d-flex flex-column">
                                <mat-form-field appearance="outline" hideRequiredMarker>
                                    <mat-label>Deductible<span class="required-input">*</span></mat-label>
                                    <input type="number" matInput placeholder="Deductible" formControlName="deductible" min="0" onchange="(function(el){el.value=parseFloat(el.value).toFixed(2);})(this)" onwheel="return false;" (keydown.arrowup)="(false)" (keydown.arrowdown)="(false)">
                                </mat-form-field>
                            </div>
                            <div class="col d-flex flex-column">
                                <mat-form-field appearance="outline" hideRequiredMarker>
                                    <mat-label>Currency<span class="required-input">*</span></mat-label>
                                    <mat-select formControlName="currency_id">
                                        <mat-option *ngFor="let currency of currencies" [value]="currency.id.toString()">
                                            {{ currency.display_text }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col d-flex flex-column">
                                <mat-form-field appearance="outline">
                                    <textarea matInput placeholder="Description" formControlName="description"></textarea>
                                </mat-form-field>
                            </div>
                        </div>
                        <ng-container *ngIf="priceRateForm.get('pricing_model_id')?.value === '1'">
                            <hr>
                            <div class="d-flex align-items-center my-4">
                                <h2 class="price-rate-sub-form-header-title">
                                    Tiered Night Pricing
                                </h2>
                            </div>
                            <form [formGroup]="tieredNightForm">
                                <div formArrayName="night_ranges">
                                    <div class="row" *ngFor="let nightRange of nightRanges().controls; let i=index" [formGroupName]="i">
                                        <div class="col d-flex flex-column">
                                            <mat-form-field appearance="outline" hideRequiredMarker>
                                                <mat-label>From<span class="required-input">*</span></mat-label>
                                                <input type="number" matInput placeholder="From" formControlName="number_of_nights_from" [disabled]="tieredNightForm.get('number_of_nights_from')?.value === 1" min="0" oninput="this.value = this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null">
                                            </mat-form-field>
                                        </div>
                                        <div class="col d-flex flex-column">
                                            <mat-form-field appearance="outline" hideRequiredMarker>
                                                <mat-label>To<span class="required-input">*</span></mat-label>
                                                <input #nightsTo type="number" matInput placeholder="To" formControlName="number_of_nights_to" (input)="setTieredNightName(i, nightsTo.value)" min="0" oninput="this.value = this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null">
                                            </mat-form-field>
                                        </div>
                                        <div class="col d-flex flex-column">
                                            <mat-form-field appearance="outline" hideRequiredMarker>
                                                <mat-label>Name<span class="required-input">*</span></mat-label>
                                                <input type="text" matInput placeholder="Name" formControlName="name">
                                            </mat-form-field>
                                        </div>
                                        <div class="col d-flex flex-column">
                                            <mat-form-field appearance="outline" hideRequiredMarker>
                                                <mat-label>Price<span class="required-input">*</span></mat-label>
                                                <input type="number" matInput placeholder="Price" formControlName="price" min="0" onchange="(function(el){el.value=parseFloat(el.value).toFixed(2);})(this)" onwheel="return false;" (keydown.arrowup)="(false)" (keydown.arrowdown)="(false)">
                                            </mat-form-field>
                                        </div>
                                        <div class="col d-flex flex-column">
                                            <button mat-mini-fab class="remove-button" *ngIf="i != 0 && i === nightRanges().length - 1" (click)="removeNightRange(i)">
                                                <mat-icon>close</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col d-flex flex-column">
                                        <mat-form-field appearance="outline" hideRequiredMarker>
                                            <mat-label>Extra Night Price
                                                <span class="required-input">*</span></mat-label>
                                            <input type="text" matInput placeholder="Name" formControlName="extra_night_price" min="0" onchange="(function(el){el.value=parseFloat(el.value).toFixed(2);})(this)" onwheel="return false;" (keydown.arrowup)="(false)" (keydown.arrowdown)="(false)">
                                        </mat-form-field>
                                    </div>
                                    <div class="col d-flex flex-column"></div>
                                    <div class="col-3 d-flex flex-column">
                                        <button mat-raised-button class="action-button" (click)="addNightRange()">
                                            Add New Tiered Night
                                        </button>
                                    </div>
                                    <div class="col d-flex flex-column"></div>
                                </div>
                            </form>
                        </ng-container>
                        <ng-container *ngIf="priceRateForm.get('pricing_model_id')?.value === '2'">
                            <hr>
                            <div class="d-flex align-items-center my-4">
                                <h2 class="price-rate-sub-form-header-title">
                                    Per Night Pricing
                                </h2>
                            </div>
                            <form [formGroup]="perNightForm">
                                <div class="row">
                                    <div class="col d-flex flex-column">
                                        <mat-form-field appearance="outline" hideRequiredMarker>
                                            <mat-label>Nightly Price 
                                                <span class="required-input">*</span>
                                            </mat-label>
                                            <input type="number" matInput placeholder="Nightly Price" formControlName="nightly_price" min="0" onchange="(function(el){el.value=parseFloat(el.value).toFixed(2);})(this)" onwheel="return false;" (keydown.arrowup)="(false)" (keydown.arrowdown)="(false)">
                                        </mat-form-field>
                                    </div>
                                    <div class="col d-flex flex-column"></div>
                                    <div class="col d-flex flex-column"></div>
                                </div>
                            </form>
                        </ng-container>
                    </form>
                </div>
                <hr>
                <mat-action-row *ngIf="!priceRateForm.valid" class="mt-3 d-flex justify-content-end">
                    <div class="d-flex justify-content-end align-items-center text-muted" style="margin-right: 3;">
                        <span class="required-input">*</span>&nbsp;- Required fields before submitting Price Rate.
                    </div>
                </mat-action-row>
            </div>
        </ng-container>
    </div>
    <div class="mt-2 mb-2 d-flex justify-content-end">
        <button mat-raised-button class="cancel-button" (click)="cancelAddPolicy()">
            <mat-icon>cancel</mat-icon>
            Cancel
        </button>
        <button mat-raised-button class="action-button"
            [disabled]="!canAssignPolicy()" (click)="submitAssignPolicy()">
            <mat-icon>check</mat-icon>
            Save Changes
        </button>
    </div>
</div>